<template>
  <div class="section">
    <div
      class="tabs-wrapper d-flex align-items-center justify-content-between w-100"
    >
      <b-button
        @click="scrollTabs('left')"
        class="mr-2 button-left"
        v-if="scrollLeft"
      >
        <font-awesome-icon :icon="['fas', 'chevron-down']" class="icon" />
      </b-button>
      <div class="tabs-scroll-container" ref="tabContainer">
        <b-tabs v-model="tabIndex">
          <b-tab :title="$t('all')" active lazy>
            <OrderDetail :status="tabIndex" />
          </b-tab>
          <b-tab :title="$t('unpaid')" lazy>
            <OrderDetail :status="tabIndex" />
          </b-tab>
          <b-tab :title="$t('toShip')" lazy>
            <OrderDetail :status="tabIndex"
          /></b-tab>
          <b-tab :title="$t('shipping')" lazy>
            <OrderDetail :status="tabIndex"
          /></b-tab>
          <b-tab :title="$t('completed')" lazy>
            <OrderDetail :status="tabIndex"
          /></b-tab>
          <b-tab :title="$t('cancellation')" lazy>
            <OrderDetail :status="tabIndex"
          /></b-tab>
          <b-tab :title="$t('returnRefund')" lazy>
            <OrderDetail :status="tabIndex"
          /></b-tab>
        </b-tabs>
      </div>
      <b-button
        @click="scrollTabs('right')"
        class="ml-2 button-right"
        v-if="scrollRight"
      >
        <font-awesome-icon :icon="['fas', 'chevron-down']" class="icon" />
      </b-button>
    </div>
  </div>
</template>

<script>
import OrderDetail from "./orderPurchase/OrderDetail.vue";

export default {
  name: "ChatOrderPurchase",
  components: {
    OrderDetail
  },
  props: {
    userChatInfo: {
      required: false,
      type: Object
    }
  },
  data() {
    return {
      tabIndex: 0,
      scrollLeft: false,
      scrollRight: true,
      fetchTimeout: null,
      currentPage: 1,
      pageSize: 10,
      orderlists: [],
      isLoading: false,
      isLoadingInfinite: false
    };
  },

  methods: {
    scrollMethod($state) {
      setTimeout(async () => {
        this.fetchOrderList(this.tabIndex, $state);
      }, 500);
    },

    scrollTabs(direction) {
      const container = this.$refs.tabContainer;

      const scrollAmount = 100;

      if (direction === "left") {
        container.scrollLeft -= scrollAmount;
      } else if (direction === "right") {
        container.scrollLeft += scrollAmount;
      }

      this.updateScroll();
    },
    updateScroll() {
      const container = this.$refs.tabContainer;
      if (!container) return;

      this.scrollLeft = container.scrollLeft > 0;

      setTimeout(() => {
        this.scrollRight =
          container.scrollWidth >
          container.clientWidth + container.scrollLeft + 1;
      }, 0);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateScroll();
      window.addEventListener("resize", this.updateScroll);
    });
  }
};
</script>

<style lang="scss" scoped>
.section {
  background-color: #fafafa;
  width: 100%;

  .tabs-wrapper {
    position: relative;
    width: 100%;

    .tabs-scroll-container {
      overflow-x: scroll;
      white-space: nowrap;
      background-color: #fff;
      font-size: 14px;
      height: 35px;
      width: 100%;
      height: 100dvh;

      &::-webkit-scrollbar {
        display: none;
      }

      ::v-deep(.nav-tabs) {
        border-bottom: none !important;
        padding: 0 5px;
        .nav-link {
          background-color: transparent !important;
          border-bottom: none !important;
          &.active {
            color: #9450c2 !important;
            background-color: transparent !important;
            border-bottom: none !important;
            font-weight: 600;
          }
        }

        &.nav {
          flex-wrap: nowrap !important;
        }
      }
    }

    .button-left,
    .button-right {
      position: absolute;
      background-color: #ebedef;
      border: 1px solid #ebedef;
      border-radius: 0;
      color: #9c9c9c;
      padding: 6px 10px;
      top: 0;
    }

    .button-right {
      right: 0;

      .icon {
        transform: rotate(270deg);
      }
    }

    .button-left {
      .icon {
        transform: rotate(90deg);
      }
    }
  }

  .content {
    overflow: auto;
    width: 100%;
    height: calc(100dvh - 260px);
    padding: 20px 0px;
  }
}

.spinner-border {
  width: 20px;
  height: 20px;
}
</style>
